import * as React from "react";
const SvgFiBrandsNapster = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-napster_svg__a)">
      <path d="M14.433 17.16a6.5 6.5 0 0 1-2.437 1.476A6.5 6.5 0 0 1 9.56 17.16z" />
      <path d="M7.428 7.498a8.7 8.7 0 0 0-3.365-1.762l-.001 7.827c0 4.388 3.541 7.886 7.939 7.886s7.933-3.513 7.933-7.9l.001-7.805a8.7 8.7 0 0 0-3.368 1.753 7.9 7.9 0 0 0-4.568-1.446 7.9 7.9 0 0 0-4.571 1.447m.02-2.285a9.8 9.8 0 0 1 4.548-1.107c1.638 0 3.183.398 4.543 1.104q.481-.304.995-.556A8.1 8.1 0 0 0 12 2.481c-2.142 0-4.09.828-5.542 2.181.315.155.686.362.99.551m-2.88-1.267A9.96 9.96 0 0 1 12.012.621a9.96 9.96 0 0 1 7.437 3.32 10.5 10.5 0 0 1 2.423-.357v3.35A4.5 4.5 0 0 1 24 10.76a4.5 4.5 0 0 1-2.136 3.831l-.014.084c-.534 4.928-4.776 8.704-9.882 8.704-5.107 0-9.31-3.844-9.841-8.776A4.55 4.55 0 0 1 0 10.76a4.5 4.5 0 0 1 2.121-3.823V3.583c.848.025 1.661.151 2.447.363" />
      <path d="M14.465 13.57c1.323-.15 3.543-.134 3.543-.134-.037.396.006 1.564-1.268 2.295-.211.121-.737.292-1.233.315-1.223.055-2.966.071-2.966.071.308-1.388.819-2.422 1.924-2.548M9.528 13.57c1.105.125 1.616 1.16 1.923 2.546 0 0-1.743-.015-2.966-.07-.496-.024-1.022-.195-1.233-.316-1.274-.73-1.231-1.898-1.268-2.294 0 0 2.22-.017 3.544.133M14.325 19.84a4.5 4.5 0 0 1-2.328.637 4.5 4.5 0 0 1-2.328-.638s.044-.262.18-.463c.168-.246.31-.317.31-.317a6.6 6.6 0 0 0 1.838.258 6.6 6.6 0 0 0 1.837-.258s.175.095.332.352c.146.237.159.428.159.428" />
    </g>
    <defs>
      <clipPath id="fi-brands-napster_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsNapster;
